export const stepData = [
  {
    id: 1,
    step: 'Loan & Personal Details',
    status: 'completed',
    link: '/mortgage/purchase/step/primary-detail',
  },
  // {
  //   id: 2,
  //   step: 'Personal Details',
  //   status: 'completed',
  //   link: '/mortgage/purchase/step/personal-detail',
  // },
  // {
  //   id: 3,
  //   step: 'Property Details',
  //   status: 'completed',
  //   link: '/mortgage/purchase/step/property-detail',
  // },
  {
    id: 4,
    step: 'Financial Details',
    status: 'completed',
    link: '/mortgage/purchase/step/income-detail',
  },
  // {
  //   id: 5,
  //   step: 'Review and Submit',
  //   status: 'completed',
  //   link: '/mortgage/purchase/step/income-detail',
  // },
];
